/* External */
import { useMemo } from 'react';

/* Utils */
import {
  getFirstGenre,
  getAllGenres,
  getFormattedDuration,
  useFullEpisodeName,
  getRating,
  getSchedule,
  isEpisode,
  isEvent,
  isMovie,
  isSports,
  joinArrayWithSeparator,
  joinArrayWithSpace,
} from '../../../utils/metaDataUtils';
import { DOT_SEPARATOR } from '../../../utils/constants';

export function usePlayerLoaderSubtitle(content, schedule) {
  const fullEpisodeName = useFullEpisodeName(content);

  return useMemo(() => {
    if (isEpisode(content)) {
      return joinArrayWithSpace([getRating(content), fullEpisodeName]);
    }

    if (!!schedule && isSports(content) && !isEvent(content)) {
      return joinArrayWithSpace([
        !isSports(content) && getRating(content),
        joinArrayWithSeparator([
          content?.shortName,
          getFormattedDuration(content),
        ]),
      ]);
    }

    return joinArrayWithSpace([
      getRating(content),
      joinArrayWithSeparator([
        getFirstGenre(content),
        isMovie(content) && content?.releaseYear,
        !schedule && getFormattedDuration(content),
      ]),
    ]);
  }, [content, fullEpisodeName, schedule]);
}

export function getPlayerLoaderSecondSubtitle({
  content, schedule, timeZone, channelName,
}) {
  if (schedule) {
    return joinArrayWithSeparator([
      schedule?.channelName || channelName,
      getSchedule(schedule, timeZone),
    ]);
  }

  if (isEpisode(content)) {
    return joinArrayWithSeparator([
      getFirstGenre(content),
      content?.releaseYear,
    ]);
  }

  return '';
}

export function usePlayerSubtitle(content, schedule) {
  const fullEpisodeName = useFullEpisodeName(content);

  return useMemo(() => {
    if (isEpisode(content)) {
      return joinArrayWithSpace([
        getRating(content),
        fullEpisodeName,
      ], DOT_SEPARATOR);
    }

    if (schedule) {
      if (isMovie(content) || isEvent(content)) {
        return joinArrayWithSpace([
          getRating(content),
          joinArrayWithSeparator(
            [
              getFormattedDuration(content),
              getAllGenres(content, DOT_SEPARATOR),
            ],
            DOT_SEPARATOR,
          ),
        ]);
      }

      if (isSports(content)) {
        return joinArrayWithSpace([
          getRating(content),
          joinArrayWithSeparator([
            content?.shortName,
            getFormattedDuration(content),
          ], DOT_SEPARATOR),
        ]);
      }
    }

    return joinArrayWithSpace([
      (!schedule && getRating(content)),
      joinArrayWithSeparator([
        isMovie(content) && content?.releaseYear,
        !schedule && getFormattedDuration(content),
        getFirstGenre(content),
      ], DOT_SEPARATOR),
    ]);
  }, [content, fullEpisodeName, schedule]);
}

export function getPlayerSecondSubtitle({
  schedule, timeZone, channelName,
}) {
  if (schedule) {
    return joinArrayWithSpace([
      <span>
        {joinArrayWithSeparator([
          getSchedule(schedule, timeZone),
          schedule?.channelName || channelName,
        ], DOT_SEPARATOR)}
      </span>,
    ]);
  }

  return '';
}
